import { LailaMessage } from '../../../../types';
import {
  ThreadItem,
  ThreadMessageMeta,
  threadItems as chatThreadItems,
} from '../../../../components/Chat/kit';

// How Laila's messages group in the shared chat thread.
export const lailaMeta = (message: LailaMessage): ThreadMessageMeta => ({
  id: message.id,
  time: message.createdAt,
  author: message.role,
  standalone: message.failed,
});

export const threadItems = (messages: LailaMessage[]): ThreadItem<LailaMessage>[] =>
  chatThreadItems(messages, lailaMeta);
